module.exports = __webpack_public_path__ + "img/menuIcon2.16fbef6a.png";